<script>
export default {
  props: {
    google: {
      type: Object,
      required: true
    },
    map: {
      type: Object,
      required: true
    },
    marker: {
      type: Object,
      required: true
    }
  },

  mounted() {
    const { Marker } = this.google.maps;
    new Marker({
      position: this.marker.position,
      marker: this.marker,
      map: this.map,
      title: this.marker.title,
      icon: { url: 'http://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi2.png' } //this.marker.icon
    });
  },

  render() { return ''; }
};
</script>
